import { api } from "../../api";

export const fleetApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFleetDashboard: builder.query({
      query: ({ equipmentCategory } = {}) => {
        const params = new URLSearchParams();
        if (equipmentCategory) params.set("equipmentCategory", equipmentCategory);
        const qs = params.toString();
        return `fleet/dashboard${qs ? `?${qs}` : ""}`;
      },
      providesTags: [{ type: "Fleet", id: "DASHBOARD" }],
    }),
    getFleetUnitDetail: builder.query({
      query: ({ id }) => `fleet/units/${id}`,
      providesTags: (_r, _e, { id }) => [{ type: "Fleet", id }],
    }),
    assignFleetDriver: builder.mutation({
      query: ({ id, assignedDriver }) => ({
        url: `fleet/units/${id}/assign-driver`,
        method: "PATCH",
        body: { assignedDriver },
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: "Fleet", id },
        { type: "Fleet", id: "DASHBOARD" },
        { type: "Equipment", id },
      ],
    }),
    linkFleetTelematics: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `fleet/units/${id}/telematics-link`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: "Fleet", id },
        { type: "Equipment", id },
      ],
    }),
    getMotiveStatus: builder.query({
      query: () => "integrations/motive/status",
      providesTags: [{ type: "Integrations", id: "MOTIVE" }],
    }),
    connectMotive: builder.mutation({
      query: (body) => ({
        url: "integrations/motive/connect",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Integrations", id: "MOTIVE" }],
    }),
    disconnectMotive: builder.mutation({
      query: () => ({
        url: "integrations/motive/disconnect",
        method: "POST",
      }),
      invalidatesTags: [{ type: "Integrations", id: "MOTIVE" }],
    }),
    getMotiveAssets: builder.query({
      query: () => "integrations/motive/assets",
      providesTags: [{ type: "Integrations", id: "MOTIVE_ASSETS" }],
    }),
    getMotiveUsers: builder.query({
      query: () => "integrations/motive/users",
      providesTags: [{ type: "Integrations", id: "MOTIVE_USERS" }],
    }),
    getMotiveVehicles: builder.query({
      query: () => "integrations/motive/vehicles",
      providesTags: [{ type: "Integrations", id: "MOTIVE_VEHICLES" }],
    }),
    syncMotiveFleet: builder.mutation({
      query: () => ({
        url: "integrations/motive/sync-fleet",
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Fleet", id: "DASHBOARD" },
        { type: "Equipment", id: "LIST" },
      ],
    }),
    getEldProviders: builder.query({
      query: () => "integrations/eld/providers",
      providesTags: [{ type: "Integrations", id: "ELD_PROVIDERS" }],
    }),
    getEldHours: builder.query({
      query: ({ driverId, provider }) => {
        const params = new URLSearchParams();
        if (driverId) params.set("driverId", driverId);
        if (provider) params.set("provider", provider);
        const qs = params.toString();
        return `integrations/eld/hours${qs ? `?${qs}` : ""}`;
      },
    }),
    linkEldDriver: builder.mutation({
      query: ({ driverId, provider, externalUserId }) => ({
        url: `integrations/eld/drivers/${driverId}/link`,
        method: "PUT",
        body: { provider, externalUserId },
      }),
    }),
    importMotiveAsset: builder.mutation({
      query: (body) => ({
        url: "integrations/motive/import",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Integrations", id: "MOTIVE" },
        { type: "Equipment", id: "LIST" },
        { type: "Fleet", id: "DASHBOARD" },
      ],
    }),
  }),
});

export const {
  useGetFleetDashboardQuery,
  useGetFleetUnitDetailQuery,
  useAssignFleetDriverMutation,
  useLinkFleetTelematicsMutation,
  useGetMotiveStatusQuery,
  useConnectMotiveMutation,
  useDisconnectMotiveMutation,
  useGetMotiveAssetsQuery,
  useGetMotiveUsersQuery,
  useGetMotiveVehiclesQuery,
  useSyncMotiveFleetMutation,
  useImportMotiveAssetMutation,
  useGetEldProvidersQuery,
  useGetEldHoursQuery,
  useLinkEldDriverMutation,
} = fleetApi;
